const actions = {
  RESET_RESULTS_STATE: 'RESET_RESULTS_STATE',
  ADD_RESULTS_TO_LIST: 'ADD_TO_RESULT_LIST',
  SHOULD_GET_RESULTS: 'SHOULD_GET_RESULTS',
  START_GETTING_RESULTS: 'START_GETTING_RESULTS',
  GET_MINUTES_PLAYED: 'UPDATE_MINUTES_PLAYED',
};

export default actions;
